import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyMemberOption} from '../../../graphql/groups.datatypes';

export interface CreateRoomPartyMemberOptionInput {
    data: {
        room_party_member_id: number
        group_resource_option_id: number
        unit_count: number
        unit_cost: number
        admin_edited: boolean
    }
}

interface CreateRoomPartyMemberOptionData {
    createRoomPartyMemberOption: RoomPartyMemberOption,
}

export const CREATE_ROOM_PARTY_MEMBER_OPTION_MUTATION = gql`
  mutation createRoomPartyMemberOption($data: CreateRoomPartyMemberOptionInput!){
    createRoomPartyMemberOption(data: $data) {
      id
      room_party_member_id
      group_resource_option_id
      unit_count
      unit_cost
      admin_edited
    }
  }
`;

export const createRoomPartyMemberOption = () => {
    return useMutation<CreateRoomPartyMemberOptionData, CreateRoomPartyMemberOptionInput>(
        CREATE_ROOM_PARTY_MEMBER_OPTION_MUTATION,
        {
            update: updateCacheByType('RoomPartyMemberOption'),
        }
    );
};

export default createRoomPartyMemberOption;